import { type ExtractPropTypes, type PropType, defineComponent } from 'vue'

// Utils
import { extend, numericProp } from '@xzx-design/utils'

import { Badge } from '@xzx-design/components'

import {
  routeProps,
  useNamespace,
  useParent,
  useRoute,
} from '@xzx-design/hooks'
import { SIDEBAR_KEY } from './sidebar'

export const sidebarItemProps = extend({}, routeProps, {
  dot: Boolean,
  title: String,
  badge: numericProp,
  disabled: Boolean,
  // badgeProps: Object as PropType<Partial<BadgeProps>>,
  badgeProps: Object as PropType<Partial<any>>,
})

export type SidebarItemProps = ExtractPropTypes<typeof sidebarItemProps>

const name = 'XzxSidebarItem'

export default defineComponent({
  name,
  props: sidebarItemProps,
  emits: ['click'],
  setup(props, { emit, slots }) {
    const { bem } = useNamespace('sidebar-item')

    const route = useRoute()
    const { parent, index } = useParent(SIDEBAR_KEY)

    if (!parent) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(
          '[Vant] <SidebarItem> must be a child component of <Sidebar>.'
        )
      }
      return
    }

    const onClick = () => {
      if (props.disabled) {
        return
      }

      emit('click', index.value)
      parent.setActive(index.value)
      route()
    }

    return () => {
      const { dot, badge, title, disabled } = props
      const selected = index.value === parent.getActive()

      return (
        <div
          role="tab"
          class={bem({
            select: selected,
            disabled,
            front: parent.currentIndex.value === index.value + 1,
            back: parent.currentIndex.value === index.value - 1,
          })}
          tabindex={disabled ? undefined : 0}
          aria-selected={selected}
          onClick={onClick}
        >
          <Badge
            dot={dot}
            class={bem('text')}
            content={badge}
            {...props.badgeProps}
          >
            {slots.title ? slots.title() : title}
          </Badge>
        </div>
      )
    }
  },
})
